export const portoguese = {
  test: 'TestPortoguese',
};
